/**
 * pp-gallery-autoplay.js
 * Auto-advances the product image gallery on mobile only.
 * Interval is configurable per-section (data-mobile-autoplay, in seconds).
 * Pauses on hover/touch interaction and when the tab/page isn't visible.
 *
 * PP1.0 speed note: autoplay waits for the page to finish loading and for the
 * gallery to actually be on screen before it starts. Otherwise it drags every
 * gallery image down over the first few seconds and slows the first paint.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var RESUME_DELAY = 2500; // ms of no interaction before autoplay resumes
  var BOOT_DELAY = 1500; // ms after page load before autoplay may start

  function initGallery(wrapper) {
    if (wrapper.__ppAutoplay) return; // already initialized
    wrapper.__ppAutoplay = true;

    var seconds = parseFloat(wrapper.getAttribute('data-mobile-autoplay')) || 3;
    var intervalMs = Math.max(seconds, 1) * 1000;

    var list = wrapper.querySelector('.product__media-list');
    if (!list) return;

    var slides = Array.prototype.slice.call(list.querySelectorAll('[id^="Slide-"]'));
    if (slides.length < 2) return; // nothing to autoplay

    var mobileMql = window.matchMedia(MOBILE_QUERY);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    var currentIndex = 0;
    var timer = null;
    var resumeTimer = null;
    var userPaused = false;
    var booted = false;
    var inView = true;

    function itemWidth() {
      return list.clientWidth || (slides[0] && slides[0].clientWidth) || 0;
    }

    function goTo(index) {
      var width = itemWidth();
      if (!width) return;
      currentIndex = ((index % slides.length) + slides.length) % slides.length;
      list.scrollTo({ left: currentIndex * width, behavior: 'smooth' });
    }

    function tick() {
      goTo(currentIndex + 1);
    }

    function start() {
      stop();
      if (!booted || !inView) return;
      if (!mobileMql.matches || userPaused || document.hidden) return;
      timer = setInterval(tick, intervalMs);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function pauseForInteraction() {
      userPaused = true;
      stop();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        userPaused = false;
        start();
      }, RESUME_DELAY);
    }

    // Pause on hover (desktop testing / stylus / trackpad-on-mobile-browser cases)
    wrapper.addEventListener('mouseenter', function () {
      userPaused = true;
      stop();
    });
    wrapper.addEventListener('mouseleave', function () {
      userPaused = false;
      if (!resumeTimer) start();
    });

    // Pause while the visitor is actually touching/swiping the gallery
    wrapper.addEventListener('touchstart', pauseForInteraction, { passive: true });
    list.addEventListener('pointerdown', pauseForInteraction);

    // Keep currentIndex in sync if the visitor manually swipes
    var scrollSyncTimer = null;
    list.addEventListener('scroll', function () {
      if (scrollSyncTimer) clearTimeout(scrollSyncTimer);
      scrollSyncTimer = setTimeout(function () {
        var width = itemWidth();
        if (!width) return;
        currentIndex = Math.round(list.scrollLeft / width);
      }, 120);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    mobileMql.addEventListener('change', function () {
      start();
    });

    // Only run while the gallery is actually on screen.
    if ('IntersectionObserver' in window) {
      inView = false;
      new IntersectionObserver(
        function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) {
            start();
          } else {
            stop();
          }
        },
        { threshold: 0.25 }
      ).observe(wrapper);
    }

    // Let the page finish loading before we start pulling in more images.
    function boot() {
      setTimeout(function () {
        booted = true;
        start();
      }, BOOT_DELAY);
    }

    if (document.readyState === 'complete') {
      boot();
    } else {
      window.addEventListener('load', boot, { once: true });
    }
  }

  function initAll() {
    document.querySelectorAll('.product__media-wrapper[data-mobile-autoplay]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after Shopify section reloads in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector && event.target.querySelector('.product__media-wrapper[data-mobile-autoplay]');
    if (wrapper) initGallery(wrapper);
  });
})();
